
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import Input from 'common/components/elements/inputs/inputs';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';
import IconLabel from 'common/components/elements/icon-label';
import BackgroundWrapper from 'common/designer-modules/modules/background-wrapper';

const MMSPageMailingList = ({
   customSiteDesignerData,
   isMobile,
   globalSettings,
}) => {
   const { getSiteSocialMediaLinks } = useSiteGlobalSettingsHelper(globalSettings);
   const socialMediaLinks = getSiteSocialMediaLinks();
   return (
      <BackgroundWrapper
         settings={ customSiteDesignerData }
         isMobile={ isMobile }
      >
         <form
            className='flex w-full max-w-[460px] gap-6 items-center justify-center' onSubmit={ (e) => { e.stopPropagation() } }>
            <div>
               <Input
                  iconName='message'
                  name='email'
                  placeholder='Enter your email'
                  type='email'
                  value=''
                  onChange={ (name, value) => {} }
                  errorMessage={ '' }
                  hasBorder
               />
            </div>
            <div className=''>
               <Button
                  text='Send'
                  textSize='base'
                  borderRadius='large'
                  onClick={ (e) => {} }
                  isLoading={ false }
                  primaryColor
                  classNames='w-full'
               />
            </div>
         </form>
         <div className='flex gap-4'>
            {
               socialMediaLinks && socialMediaLinks.map((mediaLink) => {
                  const logo = mediaLink.logo;
                  return (
                     <a href={ mediaLink.link } target='_blank' rel='noopener noreferrer'>
                        {
                           !!logo ?
                              <img src={ logo } alt='' className='group-hover:hidden w-5 h-5 rounded-full object-contain object-center' />
                              :
                              <IconLabel
                                 name='link'
                                 size='base'
                                 color='secondary'
                                 wrrapperBgColor='group-hover:!hidden bg-transparent border border-divider'
                                 className='!w-5 min-w-[20px] !h-5'
                              />
                        }
                     </a>
                  )
               })
            }

         </div>
      </BackgroundWrapper>

   );
}
MMSPageMailingList.propTypes = {
   customSiteDesignerData: PropTypes.object,
   isMobile: PropTypes.bool,
   globalSettings: PropTypes.object,
};
MMSPageMailingList.defaultProps = {
   isEditable: false,
}
export default MMSPageMailingList;


